import { AlertTriangle, RefreshCw, LogIn } from 'lucide-react';
import type { ErrorType } from '@/hooks/useApiError';

interface ApiErrorDisplayProps {
  error: string | null;
  errorType: ErrorType;
  onRetry?: () => void;
  onLogin?: () => void;
}

export function ApiErrorDisplay({ error, errorType, onRetry, onLogin }: ApiErrorDisplayProps) {
  if (!error) return null;

  return (
    <div className={`ios-card p-8 text-center ${errorType === 'auth' ? 'border-2 border-ios-red/20' : ''}`}>
      {errorType === 'auth' ? (
        <>
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <LogIn size={28} className="text-ios-red" />
          </div>
          <h3 className="text-lg font-semibold mb-2">Sesión expirada</h3>
          <p className="text-sm text-ios-gray mb-6 max-w-md mx-auto">{error}</p>
          <button
            onClick={onLogin}
            className="ios-button ios-button-destructive inline-flex items-center gap-2"
          >
            <LogIn size={16} />
            Iniciar sesión
          </button>
        </>
      ) : errorType === 'network' ? (
        <>
          <div className="w-16 h-16 bg-yellow-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertTriangle size={28} className="text-yellow-500" />
          </div>
          <h3 className="text-lg font-semibold mb-2">Error de conexión</h3>
          <p className="text-sm text-ios-gray mb-6 max-w-md mx-auto">{error}</p>
          {onRetry && (
            <button onClick={onRetry} className="ios-button inline-flex items-center gap-2">
              <RefreshCw size={16} />
              Reintentar
            </button>
          )}
        </>
      ) : (
        <>
          <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertTriangle size={28} className="text-ios-red" />
          </div>
          <h3 className="text-lg font-semibold mb-2">Error</h3>
          <p className="text-sm text-ios-gray mb-6 max-w-md mx-auto">{error}</p>
          {onRetry && (
            <button onClick={onRetry} className="ios-button inline-flex items-center gap-2">
              <RefreshCw size={16} />
              Reintentar
            </button>
          )}
        </>
      )}
    </div>
  );
}
